export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('INDEX.table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' }
  },
  {
    title: that.$l('table_label_size_and_color') || '尺寸颜色',
    field: 'goodsColor',
    minWidth: 130,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'goodsColor' }
  },
  {
    title: that.$l('table_label_in_ctn_qty') || '入数',
    field: 'inCtnQty',
    minWidth: 70,
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_ctn_qty') || '箱数',
    field: 'ctnQty',
    minWidth: 120,
    align: 'center',
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 99999999999,
        step: 1,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_goods_qty') || '产品数',
    field: 'goodsQty',
    minWidth: 80,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_fty_price') || '采购单价',
    field: 'ftyPrice',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_sub_amount') || '成本金额',
    field: 'subAmount',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) =>
      !cellValue ? cellValue : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    fixed: 'right',
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
]
